// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"7a48353d","50":"9ec3706e","135":"6f0e4e5c","280":"89385cf7","356":"5fdd535d","453":"7993f2f0","523":"eb8ab565","536":"b7a67349","744":"cb7a1d01","828":"3149dcd2","928":"2d9d8817","994":"94be9f57"}[chunkId] + ".chunk.js";
};